import BillingPriceRecurringCreateRequest from '@/datatypes/billing/price-recurring-create-request';
import BillingPriceMetadata from '@/datatypes/billing/price-metadata';
import camelcaseKeysDeep from 'camelcase-keys-deep';

export default class BillingPriceCreateRequest {
  public billingScheme: string;
  public currency: string;
  public recurring: BillingPriceRecurringCreateRequest;
  public active: boolean;
  public unitAmount: number;
  public metadata: BillingPriceMetadata = new BillingPriceMetadata({});

  constructor(options) {
    this.billingScheme = options.billingScheme;
    this.currency = options.currency;
    this.recurring = new BillingPriceRecurringCreateRequest(camelcaseKeysDeep(options.recurring));
    this.active = options.active;
    this.unitAmount = options.unitAmount;
    if (options.metadata) {
      this.metadata = new BillingPriceMetadata(camelcaseKeysDeep(options.metadata));
    }
  }
}
